import { Routes } from '@angular/router';
import { AboutUsComponent } from './container/about-us.component';

export const ABOUT_US_ROUTES: Routes = [
    {
        path: '',
        component: AboutUsComponent,
    },
];
